function initTeamSwiper() {
	const teamSwiper = document.querySelector("#teamSwiper");
	if (!teamSwiper || typeof Swiper === "undefined") {
		return;
	}

	const pagination = teamSwiper.querySelector(".team__pagination");
	const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

	new Swiper(teamSwiper, {
		slidesPerView: 1.08,
		spaceBetween: 20,
		speed: reducedMotion ? 0 : 500,
		grabCursor: true,
		watchOverflow: false,
		pagination: {
			el: pagination,
			clickable: true,
		},
		breakpoints: {
			580: {
				slidesPerView: 2,
				spaceBetween: 20,
			},
			980: {
				slidesPerView: 3,
				spaceBetween: 20,
			},
			1366: {
				slidesPerView: 4,
				spaceBetween: 20,
			},
			1520: {
				slidesPerView: 4,
				spaceBetween: 36,
			},
		},
	});
}

function initArticlesSwiper() {
	const articlesSwiper = document.querySelector("#articlesSwiper");
	if (!articlesSwiper || typeof Swiper === "undefined") {
		return;
	}

	const previousButton = document.querySelector(".boxArticles__prev");
	const nextButton = document.querySelector(".boxArticles__next");
	const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

	new Swiper(articlesSwiper, {
		slidesPerView: 1.1,
		spaceBetween: 16,
		speed: reducedMotion ? 0 : 500,
		grabCursor: true,
		watchOverflow: false,
		navigation: {
			nextEl: nextButton,
			prevEl: previousButton,
		},
		breakpoints: {
			580: {
				slidesPerView: 2,
				spaceBetween: 24,
			},
			980: {
				slidesPerView: 3,
				spaceBetween: 28,
			},
			1280: {
				slidesPerView: 4,
				spaceBetween: 32,
			},
			1520: {
				slidesPerView: 4,
				spaceBetween: 48,
			},
		},
	});
}

function initServicesExecutedSwiper() {
	const servicesExecutedSwiper = document.querySelector("#servicesExecutedSwiper");
	if (!servicesExecutedSwiper || typeof Swiper === "undefined") {
		return;
	}

	const pagination = servicesExecutedSwiper.querySelector(".servicesExecuted__pagination");
	const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

	new Swiper(servicesExecutedSwiper, {
		slidesPerView: 1.08,
		spaceBetween: 16,
		speed: reducedMotion ? 0 : 500,
		grabCursor: true,
		watchOverflow: true,
		pagination: {
			el: pagination,
			clickable: true,
		},
		breakpoints: {
			580: {
				slidesPerView: 2,
				spaceBetween: 20,
			},
			980: {
				slidesPerView: 3,
				spaceBetween: 24,
			},
			1180: {
				slidesPerView: 4,
				spaceBetween: 24,
			},
			1441: {
				slidesPerView: 5,
				spaceBetween: 30,
			},
		},
	});
}

function initProjectGallerySwiper(swiperId = "#projectGallerySwiper", modalId = "#projectGalleryModal") {
	const projectGallerySwiper = document.querySelector(swiperId);
	const projectGalleryModal = document.querySelector(modalId);

	if (!projectGallerySwiper || !projectGalleryModal || typeof Swiper === "undefined") {
		return;
	}

	const previousButton = projectGallerySwiper.closest(".projectGallery").querySelector(".projectGallery__prev");
	const nextButton = projectGallerySwiper.closest(".projectGallery").querySelector(".projectGallery__next");
	const modalPreviousButton = projectGalleryModal.querySelector(".projectGalleryModal__prev");
	const modalNextButton = projectGalleryModal.querySelector(".projectGalleryModal__next");
	const modalCloseButton = projectGalleryModal.querySelector(".projectGalleryModal__close");
	const modalSwiperElement = projectGalleryModal.querySelector(".projectGalleryModal__swiper");
	const openButtons = [...projectGallerySwiper.querySelectorAll(".projectGallery__open")];
	const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
	let lastActiveElement = null;

	new Swiper(projectGallerySwiper, {
		slidesPerView: 1.1,
		spaceBetween: 8,
		speed: reducedMotion ? 0 : 500,
		grabCursor: true,
		watchOverflow: true,
		navigation: {
			nextEl: nextButton,
			prevEl: previousButton,
		},
		breakpoints: {
			580: {
				slidesPerView: 2,
			},
			980: {
				slidesPerView: 3,
			},
		},
	});

	const modalSwiper = new Swiper(modalSwiperElement, {
		pagination: {
			el: projectGalleryModal.querySelector(".projectGalleryModal__counter"),
			type: "fraction",
			lockClass: "projectGalleryModal__counter--locked",
		},
		slidesPerView: 1,
		spaceBetween: 16,
		speed: reducedMotion ? 0 : 500,
		watchOverflow: true,
		navigation: {
			nextEl: modalNextButton,
			prevEl: modalPreviousButton,
		},
	});

	function syncVideos() {
		projectGalleryModal.querySelectorAll("video").forEach((video) => {
			video.pause();
			video.closest(".swiper-slide").inert = video.closest(".swiper-slide") !== modalSwiper.slides[modalSwiper.activeIndex];
		});
		if (projectGalleryModal.hidden) return;
		const video = modalSwiper.slides[modalSwiper.activeIndex]?.querySelector("video");
		if (video && !video.hasAttribute("src")) {
			video.src = video.dataset.src;
			video.load();
		}
	}

	modalSwiper.on("slideChange", syncVideos);

	function closeModal() {
		projectGalleryModal.hidden = true;
		syncVideos();
		document.documentElement.classList.remove("modal-active");
		lastActiveElement?.focus?.();
	}

	function openModal(index) {
		lastActiveElement = document.activeElement;
		projectGalleryModal.hidden = false;
		document.documentElement.classList.add("modal-active");
		modalSwiper.update();
		modalSwiper.slideTo(index, 0);
		syncVideos();
		modalCloseButton?.focus();
	}

	openButtons.forEach((button, index) => {
		button.addEventListener("click", () => openModal(index));
	});

	modalCloseButton?.addEventListener("click", closeModal);

	projectGalleryModal.addEventListener("click", (event) => {
		if (event.target === projectGalleryModal) {
			closeModal();
		}
	});

	document.addEventListener("keydown", (event) => {
		if (projectGalleryModal.hidden) return;
		if (event.key === "Tab") {
			const focusable = [...projectGalleryModal.querySelectorAll("button, video[controls]")]
				.filter((element) => !element.disabled && !element.closest("[inert]") && element.getClientRects().length);
			const first = focusable[0];
			const last = focusable[focusable.length - 1];
			if (event.shiftKey && document.activeElement === first) {
				event.preventDefault();
				last?.focus();
			} else if (!event.shiftKey && document.activeElement === last) {
				event.preventDefault();
				first?.focus();
			}
		}
		if (event.key === "Escape") {
			closeModal();
		}
	});
}
